export default __webpack_public_path__ + "static/media/adam.51f9e061.png";